import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { getAppStaticProps } from '~/utils/appStaticProps';
import PopmenuLogoSVG from '../../assets/svg/popmenu_loading_icon.svg';
import HungrrrLogoSVG from '../../assets/svg/hungrrr_logo.svg';

const PopmenuLoading = () => {
  const [dots, setDots] = useState<number>(0);
  const dotsIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const intl = useIntl();

  useEffect(() => {
    dotsIntervalRef.current = setInterval(() => {
      setDots(prevDots => (prevDots === 6 ? 0 : prevDots + 1));
    }, 1500);

    return () => {
      if (dotsIntervalRef.current) {
        clearInterval(dotsIntervalRef.current);
      }
    };
  }, []);

  const { platformBrand, platformBrandName } = getAppStaticProps();
  let BrandLogo;
  switch (platformBrand) {
    case 'hungrrr_platform_brand':
      BrandLogo = HungrrrLogoSVG;
      break;
    default:
      BrandLogo = PopmenuLogoSVG;
  }

  // HTML and styles shared with admin_react.html.erb
  const ellipsis = [...Array(dots).keys()].map(() => '.').join(' ');
  return (
    <div id="popmenu-loading" className="no-fade">
      <div className="icon-wrap">
        <BrandLogo className="icon icon-back" />
        <BrandLogo className="icon icon-front" />
      </div>
      <h1 className="text">{intl.formatMessage({ defaultMessage: 'Loading {brandName} {ellipsis}' }, { brandName: platformBrandName, ellipsis }).trim()}</h1>
    </div>
  );
};

export default PopmenuLoading;
